import React, { useState } from "react";
import { ExclamationCircleFilled } from '@ant-design/icons';
import { useSession } from "../utils/Session";
import { Form, Input, Button, Divider, Space } from 'antd';
import { Link, useHistory } from "react-router-dom";
import { apiCall } from "../utils/Api";
import conditional from "../utils/conditional";

function AccountSignUp() {

    const [session, setSession] = useSession();
    const history = useHistory();
    const [error, setError] = useState(false);
    const [message, setMessage] = useState("");
    const [email, setEmail] = useState("");
    const [registered, setRegistered] = useState(false);
    const [loading, setLoading] = useState(false);

    const onCheckEmail = (_status, _result) => {

        setLoading(false);
        if (!_status) {
            setError(true);
            setMessage(<div aria-live="assertive">There was an error. Please ensure you've entered a valid email address.</div>);
        } else {
            if (_result.email_address.exists) {
                setError(true);
                setRegistered(true);
                setMessage(
                    <>
                        <div aria-live="polite">Your account is already set up and ready to go!</div>
                        <div className="shim" /><div className="shim" /><div className="shim" />
                        <div style={{ "textAlign": "left", "color": "#444444" }}>
                            <div>
                                <div className="shim" /><div className="shim" />
                                You have already created an account with us, or at a bookstore using Bookmanager. All you need to do here is log in with the same email and password, and you're all set!
                                <div className="shim" /><div className="shim" />
                                If you can't remember your password, no worries, <strong onClick={() => history.push("/account/forgot")} style={{ "textDecoration": "underline", "cursor": "pointer" }}>Click here</strong> or use the <strong onClick={() => history.push("/account/forgot")} style={{ "textDecoration": "underline", "cursor": "pointer" }}>I Forgot My Password</strong> link in the Login menu to reset your password.</div>
                            <div className="shim" /><div className="shim" />
                            
                        </div>

                    </>
                );
            } else {


                if (_result.email_address.validation_required) {
                    // verify first
                    history.push({ "pathname": "/account/verify", "state": _result })
                } else {
                    // set sesssion 
                    let user = { "email_address": _result.email_address.address }
                    setSession({ ...session, "user": user });
                    history.push({ "pathname": "/account/create" })

                }


            }
        }
    }

    const checkEmail = (_form) => {

        if (loading) { return; }
        setLoading(true);
        setRegistered(false);
        setError(false);
        let { email_address } = _form;
        apiCall("account/check", { "email_address": email_address, "callback_url": "account/verify" }, onCheckEmail);
        setEmail(_form.email_address);
    }

    const display = () => {
        return (
            <div style={{ "maxWidth": "500px", "margin": "0 auto" }}>
                <h2>Create an Account</h2>
                <div aria-hidden><Divider dashed style={{ "margin": "15px 0px" }} /></div>
                <div style={{ "opacity": (loading) ? "0.7" : "1", "margin": "0 auto", "marginTop": "40px", "maxWidth": "500px", "marginTop": "10px" }}>
                    <Form onFinish={(values) => checkEmail(values)} layout="vertical">
                        <Input.Group compact>
                            <Form.Item name="email_address" noStyle>
                                <Input aria-label="Email Address" inputMode="email" size="large" type="email" style={{ "width": '74%' }} placeholder="Email Address" />
                            </Form.Item>
                            <Button aria-label="Sign Up" htmlType="submit" style={{ "width": '26%' }} size="large" type="primary">Let's Go!</Button>
                        </Input.Group>
                    </Form>


                    {/* ERROR MESSAGE */}
                    <conditional.true value={(error)}>
                        <p style={{ "paddingTop": "25px", "color": "#e70d3d", "textAlign": "center" }} className="error"><ExclamationCircleFilled /> {message}</p>
                    </conditional.true>


                    {/* ALREADY REGISTERED*/}
                    <conditional.true value={(registered)}>
                        <div className="shim" /><div className="shim" />
                        <div style={{ "margin": "0 auto", "display": "flex", "alignItems": "center", "justifyContent": "center" }}>
                            <Button onClick={() => history.push("/account/login")}>Login</Button>
                            <div>&nbsp;&nbsp;&nbsp;</div>
                            <Button onClick={() => history.push("/account/forgot")}>Reset Password</Button>
                        </div>
                    </conditional.true>

                    <br />
                    {(!message &&

                        <p>
                            Bookmanager is a large community of progressive booksellers, publishers, wholesalers, vendors, and industry friends who work hard to remain strong and independent.
                            <br /><br />
                            Once we have confirmed your role in the industry and within your company, you will have the opportunity to make connections with the companies and people within our network.
                            <br /><br />
                            Our site is used primarily by these professionals doing business within the bookselling community, and we encourage you to create a free account with us.
                        </p>
                    )}

                </div>
            </div>
        )
    }

    return display();

}

export default AccountSignUp;